export default {
  getScoreList: '/activationScore/client/activeList'
}
